import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getModuleData, getModuleVersion } from '../../../selectors/modules';
import {
  getIsMobile,
  getHasJoinedWithEclipse,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  hasFirstTimeFlag,
  FirstTimeFlag,
} from '@wix/da-shared-react/pkg/redux/firstTimeFlags';
import { isEditorTextEmpty } from '@wix/da-shared-react/pkg/DaEditorWrapper/utils';
import { Props as WidgetProps } from './AboutMe';
import { Props as BoxProps } from './AboutMeBox';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
  getProfileOwnerIsWatcher,
} from '../../../selectors/users';
import { AboutModuleType } from '../../../../types/papi';
import { AboutMeMode } from './types';

type Props = BoxProps & WidgetProps;
type StateProps = Pick<
  Props,
  | 'isArtist'
  | 'website'
  | 'badges'
  | 'socialLinks'
  | 'countryId'
  | 'moduleVersion'
  | 'bio'
  | 'user'
  | 'isCurrentUserProfileOwner'
  | 'isEmpty'
  | 'isMobile'
  | 'withFTUE'
  | 'hasJoinedWithEclipse'
  | 'isWatchingYou'
>;

type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const moduleVersion = getModuleVersion(state, ownProps.moduleId);
  const aboutMeData: AboutModuleType = getModuleData(state, ownProps.moduleId);
  const {
    isArtist,
    website,
    badges,
    socialLinks,
    textContent,
    countryId,
  } = aboutMeData;
  const hasSocialLinks = socialLinks && socialLinks.length > 0;
  const hasBadges = badges && badges.length > 0;
  const isMobile = getIsMobile(state);
  const isBioEmpty = isEditorTextEmpty(textContent);
  const isEmpty =
    (isMobile &&
      ownProps.mode !== undefined &&
      ownProps.mode !== AboutMeMode.DEFAULT &&
      isBioEmpty) || // TODO: this should be done in AboutMeBox.tsx
    (!isArtist &&
      !website &&
      !hasBadges &&
      !hasSocialLinks &&
      !textContent &&
      !countryId);

  return {
    ...aboutMeData,
    moduleVersion,
    bio: textContent,
    user: getProfileOwnerUser(state),
    isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
    isEmpty,
    isMobile,
    hasJoinedWithEclipse: getHasJoinedWithEclipse(state),
    withFTUE: Boolean(
      isBioEmpty &&
        hasFirstTimeFlag(state, FirstTimeFlag.ProfileHeroAidNotClosed)
    ),
    isWatchingYou: getProfileOwnerIsWatcher(state),
  };
};

export default connect(mapStateToProps);
